import { Component } from '@angular/core';
import { ModalComponent } from '../../../../../models/modal-component';

@Component({
    selector: 'app-no-internet-modal',
    templateUrl: './no-internet-modal.component.html',
    styleUrls: ['./no-internet-modal.component.scss'],
    standalone: true
})
export class NoInternetModalComponent extends ModalComponent {
    static MODAL_ID = 'noInternetModal';

    getId(): string {
        return NoInternetModalComponent.MODAL_ID;
    }
}
